import {
    Store
} from 'vuex';
import {
    IGlobalState
} from '@/store';
import * as Types from '@/store/action-types';
import { IDictItem } from '@/typings/dict';

/**
 * 使用字典列表
 */
export async function useDictList(store: Store<IGlobalState>, typecode: number,page:number = 1,limit:number = 10) {
    // 从接口获取字典列表
    let params = {
        typecode: typecode,
        page:page,
        limit:limit
    }
    await store.dispatch(`dict/${Types.SET_DICT_LIST}`, params);
};

// 改变当前选择字典
export async function setCurrentDictItem(store: Store<IGlobalState>,dictItem: IDictItem) {
    store.commit(`dict/${Types.SET_CUR_DICT}`, dictItem);
}